/**
 * Zoom de la interfaz por usuario (CSS `zoom` sobre <html>).
 *
 * El valor real vive en el usuario (`uiZoom` en /api/users/myprofile). localStorage
 * guarda una copia por userId para aplicarlo al instante al cargar, antes de que
 * responda el perfil, sin mezclar usuarios que comparten navegador.
 *
 * Con zoom en <html>, `100vh` mide más que la ventana (se multiplica por el zoom).
 * La clase `ui-zoomed` y la variable `--ui-zoom` permiten compensar el layout en uiZoom.css.
 */

export const UI_ZOOM_MIN = 80;
export const UI_ZOOM_MAX = 150;
export const UI_ZOOM_STEP = 10;
export const UI_ZOOM_DEFAULT = 100;

const STORAGE_KEY_PREFIX = "uiZoom_";

export function normalizeUiZoom(value) {
  const n = Math.round(Number(value) / UI_ZOOM_STEP) * UI_ZOOM_STEP;
  if (!Number.isFinite(n)) return UI_ZOOM_DEFAULT;
  return Math.min(UI_ZOOM_MAX, Math.max(UI_ZOOM_MIN, n));
}

export function applyUiZoom(value) {
  const zoom = normalizeUiZoom(value);
  const root = document.documentElement;
  if (zoom === UI_ZOOM_DEFAULT) {
    root.style.removeProperty("zoom");
    root.style.removeProperty("--ui-zoom");
    root.classList.remove("ui-zoomed");
  } else {
    const factor = zoom / 100;
    root.style.zoom = String(factor);
    root.style.setProperty("--ui-zoom", String(factor));
    root.classList.add("ui-zoomed");
  }
  return zoom;
}

export function readCachedUiZoom(userId) {
  if (!userId) return UI_ZOOM_DEFAULT;
  try {
    const raw = localStorage.getItem(STORAGE_KEY_PREFIX + userId);
    return raw == null ? UI_ZOOM_DEFAULT : normalizeUiZoom(raw);
  } catch (e) {
    return UI_ZOOM_DEFAULT;
  }
}

export function cacheUiZoom(userId, value) {
  if (!userId) return;
  try {
    localStorage.setItem(
      STORAGE_KEY_PREFIX + userId,
      String(normalizeUiZoom(value))
    );
  } catch (e) {
    // Sin localStorage el zoom igual se aplica desde el perfil al cargar.
  }
}
